import React from 'react'
import { Card, CardContent, Typography, Grid } from '@mui/material'
import { Icon as IconifyIcon } from "@iconify/react"
import './DashboardStats.scss'

export default function DashboardStats({ stats }) {
    const statCards = [
        {
            title: 'Fälle (Cases)',
            value: stats?.totalCases || 0,
            icon: 'mdi:file-document-multiple',
            color: '#1976d2'
        },
        {
            title: 'Varianten',
            value: stats?.totalVariants || 0,
            icon: 'mdi:dna',
            color: '#9c27b0'
        },
        {
            title: 'Aktive Labore',
            value: stats?.activeLabs || 0,
            icon: 'mdi:hospital-building',
            color: '#2e7d32'
        }
    ]

    return (
        <Grid container spacing={3} className="dashboard-stats">
            {statCards.map((stat, index) => (
                <Grid item xs={12} sm={6} md={4} key={index}>
                    <Card className="stat-card">
                        <CardContent>
                            <div className="stat-header">
                                <IconifyIcon 
                                    icon={stat.icon} 
                                    className="stat-icon"
                                    style={{ color: stat.color }}
                                />
                                <Typography variant="subtitle2" className="stat-title">
                                    {stat.title}
                                </Typography>
                            </div>
                            <Typography variant="h3" className="stat-value">
                                {stat.value.toLocaleString('de-DE')}
                            </Typography>
                            <Typography variant="caption" className="stat-period">
                                Gesamt
                            </Typography>
                        </CardContent>
                    </Card>
                </Grid>
            ))}
        </Grid>
    )
}